export default __webpack_public_path__ + "static/media/Shoes7.953a2fd0.png";